import { render, staticRenderFns } from "./BaseNotification.vue?vue&type=template&id=1c27e21e&scoped=true"
import script from "./BaseNotification.vue?vue&type=script&lang=ts"
export * from "./BaseNotification.vue?vue&type=script&lang=ts"
import style0 from "./BaseNotification.vue?vue&type=style&index=0&id=1c27e21e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c27e21e",
  null
  
)

export default component.exports